var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddTicket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0ZM12 6C11.6203 6 11.3065 6.28215 11.2568 6.64823L11.25 6.75V11.25H6.75C6.33579 11.25 6 11.5858 6 12C6 12.3797 6.28215 12.6935 6.64823 12.7432L6.75 12.75H11.25V17.25C11.25 17.6642 11.5858 18 12 18C12.3797 18 12.6935 17.7178 12.7432 17.3518L12.75 17.25V12.75H17.25C17.6642 12.75 18 12.4142 18 12C18 11.6203 17.7178 11.3065 17.3518 11.2568L17.25 11.25H12.75V6.75C12.75 6.33579 12.4142 6 12 6Z",
    fill: "#34495E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddTicket);
export default __webpack_public_path__ + "static/media/add-ticket.87cc62cbbda5a5088913a716ce94caae.svg";
export { ForwardRef as ReactComponent };